import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  isPayoutOnlyAdmin,
  isPathAllowedForPayoutOnlyAdmin,
} from "../common/adminAccess";

export default function PayoutOnlyGuard({ children }) {
  const adminData = useSelector((state) => state.AppDataReducer);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isPayoutOnlyAdmin(adminData)) return;
    if (!isPathAllowedForPayoutOnlyAdmin(location.pathname)) {
      navigate("/payoutListAdmin", { replace: true });
    }
  }, [adminData, location.pathname, navigate]);

  return children;
}
